export const APP_URL =
  import.meta.env.VITE_APP_URL || `https://${import.meta.env.VITE_VERCEL_BRANCH_URL}`

// Cache TTL in milliseconds. Override via VITE_CACHE_TTL env variable (default: 5 minutes)
export const CACHE_TTL = Number(import.meta.env.VITE_CACHE_TTL) || 5 * 60 * 1000
